import { render } from "./ChooseShop.vue?vue&type=template&id=1cc4712d&scoped=true"
import script from "./ChooseShop.vue?vue&type=script&lang=ts"
export * from "./ChooseShop.vue?vue&type=script&lang=ts"

import "./ChooseShop.vue?vue&type=style&index=0&id=1cc4712d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1cc4712d"

export default script